<form name="form" #f="ngForm">
    <fieldset>
        <div>
          <div class="row">
            <div class="col-md-2 mb-2">
              <label for="delegateId">Delegate</label>
            </div>
            <div class="col-md-10 mb-10">
              <img style="float:right;cursor:pointer" src="design/images/close-light.png" (click)="onClose()" />
            </div>
          </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <select name="delegateId" required class="form-control form-control-sm" [(ngModel)]="delegateId" [disabled]="delegateSaved">
                        <option [ngValue]="0" >
                            Select
                        </option>
                        <option *ngFor="let u of userList" [value]="u.id">{{u.name}}</option>
                    </select>
                </div>

                <div class="col-md-6 mb-2">

                    <button (click)="updateDelegate(f)" class="btn btn-secondary" [disabled]="delegateSaved">
                        <span>Set delegate</span>
                    </button>

                    &nbsp;

                    <button (click)="setNoDelegate(f)" class="btn btn-outline-primary" [disabled]="!delegateSaved">
                        <span>Remove delegate</span>
                    </button>

                </div>

            </div>
            <div class="row">
            </div>
            <div>
            <label>Email signature</label>
            <div class="row">
                <div class="col-sm-9">
            <editor name="email" [init]="toolbarConfig" [(ngModel)]="emailSignature"></editor>
            <button (click)="saveEmailSignature()" class="btn btn-secondary mt-2">
                <span>Save signature</span>
            </button>
            <button (click)="getDefaultEmailSignature()" class="btn btn-outline-primary mt-2 ms-2">
                <span>Refresh signature</span>
            </button>
            </div>
        </div>
            </div>            
        </div>
    </fieldset>
</form>
